const CORGI = "Corgi Trucking";

export function getCorgiIneligibilityReason(data) {
  const step1 = data?.step1 ?? {};
  const step3 = data?.step3 ?? {};
  const operations = Array.isArray(step3.business_description)
    ? step3.business_description
    : [];

  if (step1.hazmatPlacard) return "Corgi Trucking does not accept hazmat operations.";
  if (operations.includes("household_goods_mover") || step3.corgiPassengerOperations) {
    return "Corgi Trucking does not accept household-goods or passenger operations.";
  }
  if (step3.brokerageAuthority || step3.corgiFreightForwarder) {
    return "Corgi Trucking does not accept freight brokers or freight forwarders.";
  }
  if (operations.includes("dump_truck_sand_gravel") || step3.corgiTransitMixerOperations) {
    return "Corgi Trucking does not accept sand, gravel, rock, or transit-mixer operations.";
  }
  if (step3.corgiDeliveryCourierOperations) {
    return "Corgi Trucking does not accept delivery or courier operations.";
  }
  if (step3.corgiArmoredVehicles) {
    return "Corgi Trucking does not accept armored vehicles.";
  }
  if (step3.teamDrivers) return "Corgi Trucking does not accept team drivers.";
  if (step3.travelMexico) return "Corgi Trucking does not accept Mexico exposure.";
  if (step3.corgiMostRunsUnder100Miles) {
    return "Corgi Trucking does not accept risks where most runs are under 100 miles.";
  }

  return null;
}

export function removeCorgiCarrier(carriers) {
  const list = Array.isArray(carriers) ? carriers : carriers ? [carriers] : [];
  return list.filter((carrier) => carrier !== CORGI);
}
